// extracted by mini-css-extract-plugin
export default {"markdown":"markdown_styles_markdown__k0v5D","reactMarkDown":"markdown_styles_reactMarkDown__fUKlU","reactMarkdown":"markdown_styles_reactMarkdown__JHJx6"};